import React from 'react';
import { useTranslation } from 'react-i18next';
import './SearchCard.css';

function SearchCard({ result, language, onClick }) {
    const { t } = useTranslation();

    const getTitle = () => {
        // Backend now returns language-specific title directly
        return result.title || result.application || '';
    };

    const getSnippet = () => {
        // Backend now uses 'html' instead of 'detail'
        const content = result.html || result.detail;
        if (!content) return '';

        // First remove style and script tags with their content
        let text = content
            .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
            .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
            .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '');

        // Then strip remaining HTML tags
        text = text.replace(/<[^>]*>/g, '');

        // Clean up extra whitespace
        text = text.replace(/\s+/g, ' ').trim();

        // Decode HTML entities
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        text = textarea.value;

        return text.length > 150 ? text.substring(0, 150) + '...' : text;
    };

    return (
        <div className="search-card" onClick={onClick}>
            <div className="search-card-header">
                <span className="search-card-app">{result.application}</span>
            </div>
            <h3 className="search-card-title">{getTitle()}</h3>
            <p className="search-card-snippet">{getSnippet()}</p>
            <span className="search-card-link">{t('readMore')}</span>
        </div>
    );
}

export default SearchCard;
